import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("gt_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("gt_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("gt_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("gt_token");
    setUser(null);
  };

  const isAdmin = user?.role === "admin" || user?.role === "master_admin";
  const isMaster = user?.role === "master_admin";
  const can = (perm) => isAdmin || Boolean(user?.permissions?.[perm]);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, isAdmin, isMaster, can }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
